export const profilesConstants = {
  OPERACIONES_ID: 1,
  RESPONSABLE_CAJA_ID: 2,
  CENTRODECOSTO_ID: 3,
  ANALISTA_CONTABILIDAD_ID: 4,
  ADMINISTRACION_ID: 7,
  RESPONSABLE_CAJA_READONLY_ID: 9,
  TREASURY_ID: 8,
  PLANIFICADOR_ID: 10,
  SUPERVISOR_ID: 11,
  RESPONSABLE_EMPLEADO_ID: 12,
  RESPONSABLE_VEHICULOS_ID: 13,
}
